/**
 * Every game kikik.id has released. There is exactly one.
 *
 * This file is deliberately short and deliberately honest. No ratings, no
 * player counts, no "most popular", no placeholder titles for games that do
 * not exist. When a second game ships it is added here, and the portal's
 * shelves, moods, search and coming-soon states all follow from that.
 *
 * Mahjong's moods are the ones it truthfully earns. It is not tagged
 * "quick-play" - a round takes a while - and it is not tagged "relax", because
 * a beginner's first game is work. Two moods therefore have no games at all,
 * which is the correct answer today.
 */

import type { GameEntry } from "./types.js";

export const MAHJONG: GameEntry = {
  slug: "mahjong",
  titleKey: "portal.game.mahjong.title",
  taglineKey: "portal.game.mahjong.tagline",
  descriptionKey: "portal.game.mahjong.description",
  category: "board-strategy",
  moods: [
    "brain-boost",
    "learn-through-play",
    "timeless-classics",
    "challenge",
    "play-together",
    "new-on-kikik",
  ],
  status: "playable",
  platforms: ["web"],
  artwork: { motif: "mahjong-tiles", accent: "jade" },
  featured: true,
  launch: { kind: "internal", route: "mahjong" },
};

export const GAMES: readonly GameEntry[] = [MAHJONG];
